import { useTranslation } from 'react-i18next';
import { useGetFullNameRule, useGetPasswordRule, useGetRequiredRule } from '@/hooks';
import { AdminProfileFieldsNames, ChangePasswordFieldsNames } from '../helpers/types';

export const useAdminProfileRules = () => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });
  const nameRule = useGetFullNameRule({ t });

  return {
    [AdminProfileFieldsNames.FIRST_NAME]: [nameRule, requiredRule],
    [AdminProfileFieldsNames.LAST_NAME]: [nameRule, requiredRule],
  };
};

export const useChangePasswordRules = () => {
  const { t } = useTranslation(['validations']);

  const passwordRule = useGetPasswordRule({ t });
  const requiredRule = useGetRequiredRule({ t });

  return {
    [ChangePasswordFieldsNames.OLD_PASSWORD]: [requiredRule],
    [ChangePasswordFieldsNames.PASSWORD]: [requiredRule, passwordRule],
    [ChangePasswordFieldsNames.PASSWORD]: [requiredRule, passwordRule],
    [ChangePasswordFieldsNames.CONFIRM_PASSWORD]: [requiredRule, passwordRule],
  };
};
